module.exports = __webpack_public_path__ + "static/media/cockroach(17).fdf757cc.PNG";